<template>
    <section class="slider-section">
        <div class="slider-container">
            <div 
                v-for="(slide, index) in sliders" 
                :key="slide.id"
                :class="['slide', { 'active': currentSlide === index }]"
            >
                <div 
                    class="slide-background" 
                    :style="slide.imagen ? `background-image: url('/storage/${slide.imagen}')` : ''"
                >
                </div>
                <div class="slide-content">
                    <h2 v-if="slide.titulo" v-html="slide.titulo"></h2>
                    <p v-if="slide.descripcion" v-html="slide.descripcion"></p>
                    <!-- BOTÓN CON ENLACE DEL MODELO -->
                    <router-link 
                        v-if="slide.url_boton" 
                        :to="slide.url_boton" 
                        class="slide-cta"
                    >
                        {{ slide.texto_boton || 'Ver Más' }}
                    </router-link>
                </div>
            </div>
            
            <!-- Default slide if no sliders -->
            <div v-if="!sliders || sliders.length === 0" class="slide active">
                <!-- <div class="slide-background"></div>
                <div class="slide-content">
                    <h2>Soluciones POS de Última Generación</h2>
                    <p>Equipos de punto de venta, lectores de código de barras y tecnología que impulsa tu negocio</p>
                    <router-link to="/contacto" class="slide-cta">Ver Equipos</router-link>
                </div> -->
            </div>
        </div>
        
        <div class="slider-dots" v-if="sliders && sliders.length > 1">
            <span 
                v-for="(slide, index) in sliders" 
                :key="`dot-${index}`"
                :class="['dot', { 'active': currentSlide === index }]"
                @click="goToSlide(index)"
            ></span>
        </div>
    </section>
</template>

<script>
export default {
    name: 'HeroSlider',
    props: {
        sliders: {
            type: Array,
            default: function() { return []; }
        }
    },
    data() {
        return {
            currentSlide: 0,
            intervalId: null
        };
    },
    mounted() {
        if (this.sliders && this.sliders.length > 1) {
            this.startAutoSlide();
        }
    },
    beforeDestroy() {
        this.stopAutoSlide();
    },
    methods: {
        startAutoSlide() {
            this.intervalId = setInterval(() => {
                this.nextSlide();
            }, 5000);
        },
        stopAutoSlide() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
        },
        nextSlide() {
            this.currentSlide = (this.currentSlide + 1) % this.sliders.length;
        },
        goToSlide(index) {
            this.currentSlide = index;
            this.stopAutoSlide();
            this.startAutoSlide();
        }
    }
};
</script>

<style scoped>
.slider-section {
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: 600px;
    margin: 0;
    padding: 0;
    overflow: hidden;
}

.slider-container {
    width: 100%;
    height: 100%;
    position: relative;
}

.slide {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 1s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
}

.slide.active {
    opacity: 1;
    z-index: 1;
}

.slide-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, var(--primary-dark), var(--primary-blue));
    background-size: cover;
    background-position: center;
    z-index: 0;
}

.slide-background::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: 
        linear-gradient(135deg, rgba(10, 22, 40, 0.8), rgba(30, 58, 95, 0.7)),
        radial-gradient(circle at 20% 50%, rgba(212, 175, 55, 0.15), transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(45, 212, 191, 0.15), transparent 50%);
}

.slide-content {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 1200px;
    padding: 0 2rem;
    margin: 0 auto;
    text-align: center;
}

.slide-content h2 {
    font-family: 'Playfair Display', serif;
    font-size: 4rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
    line-height: 1.2;
    background: linear-gradient(135deg, var(--text-light), var(--accent-gold));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: slideIn 1s ease-out;
}

.slide-content p {
    font-size: 1.3rem;
    color: var(--text-gray);
    max-width: 700px;
    margin: 0 auto 2rem;
    font-weight: 300;
    animation: slideIn 1s ease-out 0.2s backwards;
}

.slide-cta {
    display: inline-block;
    padding: 1rem 2.5rem;
    background: linear-gradient(135deg, var(--accent-gold), var(--accent-teal));
    color: var(--primary-dark);
    text-decoration: none;
    border-radius: 50px;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 10px 30px rgba(212, 175, 55, 0.3);
    animation: slideIn 1s ease-out 0.4s backwards;
}

.slide-cta:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 40px rgba(212, 175, 55, 0.4);
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.slider-dots {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 12px;
    z-index: 2;
}

.dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
    cursor: pointer;
    transition: all 0.3s ease;
}

.dot:hover {
    background: rgba(212, 175, 55, 0.5);
    transform: scale(1.2);
}

.dot.active {
    background: var(--accent-gold);
    width: 30px;
    border-radius: 6px;
}

/* RESPONSIVE */
@media (max-width: 1024px) {
    .slider-section {
        height: 80vh;
        min-height: 550px;
    }
    
    .slide-content h2 {
        font-size: 3rem;
    }
    
    .slide-content p {
        font-size: 1.1rem;
    }
}

@media (max-width: 768px) {
    .slider-section {
        height: 70vh;
        min-height: 500px;
    }
    
    .slide-content h2 {
        font-size: 2.5rem;
    }
    
    .slide-content p {
        font-size: 1rem;
    }
    
    .slide-cta {
        padding: 0.8rem 2rem;
        font-size: 0.9rem;
    }
}

@media (max-width: 640px) {
    .slider-section {
        height: 60vh;
        min-height: 450px;
    }
    
    .slide-content h2 {
        font-size: 2rem;
    }
    
    .slide-content p {
        font-size: 0.95rem;
    }
}
</style>